import { Box, Drawer, DrawerContent, DrawerOverlay, Flex, useDisclosure } from '@chakra-ui/react';
import { SeasonalEffect } from 'components/SeasonalEffect/SeasonalEffect';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { ToggleButton } from './ToggleButton';

export const Navbar = (props: { permissions?: string[]; isLoading: boolean }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { permissions, isLoading } = props;
  const { pathname } = useLocation();

  useEffect(() => {
    // Close the mobile drawer when the route changes
    onClose();
  }, [pathname, onClose]);

  return (
    <Box position="relative" isolation="isolate" width="full" py="4" px={{ base: '4', md: '8' }} bg="default">
      <SeasonalEffect />
      <Flex justify="space-between">
        <ToggleButton isOpen={isOpen} aria-label="Open Menu" onClick={onToggle} />
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          isFullHeight
          preserveScrollBarGap
          // Only disabled for showcase
          trapFocus={false}
        >
          <DrawerOverlay />
          <DrawerContent pt={10} bg="default">
            <Sidebar permissions={permissions} isLoading={isLoading} isMobile />
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  );
};
